import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-billing-details',
  templateUrl: './billing-details.component.html',
  styleUrls: ['./billing-details.component.scss'],
})
export class BillingDetailsComponent {
  @Input() shipmentForm: FormGroup;
  @Input() shipmentData: any;
  //constructor() {}

  //ngOnInit(): void {}
}
